import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export default function useCurrentLanguage() {
  const { i18n } = useTranslation();
  const language = useMemo(() => i18n.language, [i18n.language]);
  return language;
}
